import './App.css';
import { Route, Switch, Redirect } from 'react-router-dom';
import React, { useEffect } from "react";
import Navbar from './Components/Lynkit/Component/Navbar/Navbar';
import ScrollToTop from './Components/ScrollToTop';
// import * as React from 'react';
import { Helmet } from "react-helmet";
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import loaderGif from './Components/Lynkit/assets/loader.gif';
// import CaseStudy1MPS from './Components/Lynkit/pages/UseCases1_MPS';
import YMS from './Components/LandingPage/yms';
import Privacy_policy from './Components/Lynkit/Component/Footer/Privacy_policy';
import General_terms_of_use from './Components/Lynkit/Component/Footer/General_terms_of_use';

const KnowledgeBank = React.lazy(() => import('./Components/KnowledgeBank'));
const Api = React.lazy(() => import('./Components/Api'));
const Posts = React.lazy(() => import('./Components/Posts'));
const Blog = React.lazy(() => import('./Components/Blog'));
const BlogEntry = React.lazy(() => import('./Components/BlogEntry'));
const Xeneta = React.lazy(() => import('./Components/LandingPage/Xeneta'));
const ContactUsXBL = React.lazy(() => import('./Components/LandingPage/Xeneta/contact_us'));
const Ebook = React.lazy(() => import('./Components/Ebook'));
// const Videos = React.lazy(() => import('./Components/Videos'));
const LynkID = React.lazy(() => import('./Components/LandingPage/LynkID'));
const Patent = React.lazy(() => import('./Components/Patient'));
const ResourcesXBL = React.lazy(() => import('./Components/LandingPage/Xeneta/components/ResourcesXBL'));
const ROICalculator = React.lazy(() => import('./Components/LandingPage/Xeneta/components/roiCalculator'));



 const Home = React.lazy(() => import("./Components/Home"))

const About_us = React.lazy(() => import("./Components/About_us"))
// const About_us = React.lazy(() => import("./Components/Lynkit/pages/AboutUs/index"))
const Advisory_Board = React.lazy(() => import("./Components/Advisory"))
// const Case_studies = React.lazy(() => import("./Components/Case_studies"))
// const Case_study_1_GPS = React.lazy(() => import("./Components/Case_study_1_GPS"))
// const Case_study_2 = React.lazy(() => import("./Components/Case_study_2"))
// const Case_study_3 = React.lazy(() => import("./Components/Case_study_3"))
// const Case_study_4 = React.lazy(() => import("./Components/Case_study_4"))
// const Case_study_5 = React.lazy(() => import("./Components/Case_study_5"))
// const Case_study_6 = React.lazy(() => import("./Components/Case_study_6"))
// const ContactUs = React.lazy(() => import("./Components/ContactUs"))
const ContactUs = React.lazy(() => import("./Components/Lynkit/pages/ContactUs"))
// const Careers = React.lazy(() => import("./Components/Careers"))
const Lynkhub = React.lazy(() => import("./Components/Lynkhub"))
const LandingPage = React.lazy(() => import("./Components/LandingPage"))
const LynkitIOLandingPage= React.lazy(() => import("./Components/LandingPage/LynkitIOLandingPage"))
const WMS= React.lazy(() => import("./Components/LandingPage/wms"))
const UseCases = React.lazy(() => import('./Components/Lynkit/pages/UseCases'));
const CaseStudy1MPS = React.lazy(() => import('./Components/Lynkit/pages/UseCases/MPS_CaseStudy'));
const CMA_CGM_CaseStudy = React.lazy(() => import('./Components/Lynkit/pages/UseCases/CMA_CGM_CaseStudy'));
const Haier_CaseStudy = React.lazy(() => import('./Components/Lynkit/pages/UseCases/Haier_CaseStudy'));
const Flipkart_CaseStudy = React.lazy(() => import('./Components/Lynkit/pages/UseCases/Flipkart_CaseStudy'));
const BlueDart_CaseStudy = React.lazy(() => import('./Components/Lynkit/pages/UseCases/BlueDart_CaseStudy'));
const DHL_CaseStudy = React.lazy(() => import('./Components/Lynkit/pages/UseCases/DHL_CaseStudy'));
const ICD_CaseStudy = React.lazy(() => import('./Components/Lynkit/pages/UseCases/ICD_CaseStudy'));
const AiPage = React.lazy(() => import('./Components/Lynkit/pages/AiPage'));
const LoaderOverlay = () => (
  <div style={{
    position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
    background: '#000000', display: 'flex',
    alignItems: 'center', justifyContent: 'center', zIndex: 99999
  }}>
    <img src={loaderGif} alt="Loading..." />
  </div>
);

const pageMeta = {
  "/": {
    title: "AI Powered Supply Chain Management & Cargo Tracking Software",
    description: "Lynkit offers AI-powered supply chain management software with cargo tracking to improve logistics visibility, supply chain automation, and operational efficiency.",
  },
  "/about_us/partners": {
    title: "Partners About us - Lynkit",
    description: "Explore Lynkit's trusted partners and alliances driving innovation in supply chain management, logistics technology, and transport automation across India.\"",
  },
  "/advisory_board": {
    title: "Advisory_Board - Lynkit",
    description: "Meet Lynkit's Advisory Board \u2014 Industry experts guiding our vision in supply chain management, logistics technology, and transport automation.",
  },
  "/api": {
    title: "Api - Lynkit",
    description: "Explore Lynkit's API for seamless integration with TMS, WMS, and supply chain automation platforms built for developers and enterprises.",
  },
  // "/careers": {
  //   title: "Grow with Lynkit - Careers",
  //   description: "Not opening",
  // },
  // "/case_studies": {
  //   title: "Case Studies - Lynkit",
  //   description: "Discover real success stories of businesses using Lynkit's TMS and WMS to optimize logistics, warehouse operations, and supply chain automation.",
  // },
  // "/case_study_1_gps": {
  //   title: "GPS Tracking & Security Services for Cargo Movement - Lynkit",
  //   description: "See how Lynkit's GPS tracking and security solutions helped secure cargo movement, prevent theft, and ensure real-time visibility across transit routes.",
  // },
  // "/case_study_2": {
  //   title: "Transport Management System for Logistics - Lynkit",
  //   description: "Discover how Lynkit's Transport Management System helped a logistics company streamline operations, optimize routes, and improve delivery efficiency.",
  // },
  // "/case_study_3": {
  //   title: "RFID Based Vehicle Management System - Lynkit",
  //   description: "Explore how Lynkit's RFID-based Vehicle Management System improved tracking accuracy, automated vehicle entry, and streamlined fleet operations.",
  // },
  // "/case_study_4": {
  //   title: "GPS Tracking & Security Services for Korean Manufacturer - Lynkit",
  //   description: "Learn how Lynkit's GPS tracking and security services helped a Korean manufacturer safeguard shipments and gain real-time visibility across logistics.",
  // },
  // "/case_study_5": {
  //   title: "Lynkgrid 2D Warehouse Management System in Dadri - Lynkit",
  //   description: "See how Lynkit's Lynkgrid 2D Warehouse Management System optimized storage, tracking, and operations for a warehouse facility in Dadri.",
  // },
  // "/case_study_6": {
  //   title: "Parolees Tracking to Lynkband for South Asia's Largest Prison - Lynkit",
  //   description: "Discover how Lynkit's Lynkband technology enabled real-time parolee tracking and monitoring for South Asia's largest prison facility.",
  // },
  "/contactus": {
    title: "Contact Lynkit | Supply Chain Automation Experts",
    description: "Get in touch with Lynkit, a trusted Supply Chain Automation company in India. Contact us for TMS, WMS, and logistics technology solutions \u2014 book a demo today.",
  },
  "/patent": {
    title: "Our Patents - Lynkit",
    description: "Explore Lynkit's patented technologies in GPS tracking, RFID, and logistics automation \u2014 reflecting our commitment to innovation in supply chain solutions.",
  },
  "/about_us": {
    title: "About Lynkit | Supply Chain Automation Company in India",
    description: "Learn about Lynkit, a leading Supply Chain Automation company in India, empowering businesses with TMS, WMS, and IoT-driven logistics solutions.",
  },
  "/e-book": {
    title: "E-book on How to boost your warehouse operations? Download Now",
    description: "Download Lynkit's free e-book to learn practical strategies for boosting warehouse efficiency, reducing errors, and optimizing storage operations.",
  },
  "/enterprise": {
    title: "Enterprise Logistics Software | TMS & WMS - Lynkit",
    description: "Lynkit offers enterprise-grade TMS and WMS solutions to help large businesses automate logistics, optimize fleet and warehouse operations at scale.",
  },
  "/knowledge-bank": {
    title: "Know more about IoT, GNSS, RFID and Logistics - Lynkit",
    description: "Explore Lynkit's knowledge bank to learn about IoT, GNSS, RFID, and logistics technology powering modern supply chain and transport management.",
  },
  "/asset-tracking-system": {
    title: "AI-Driven Asset Tracking & Gate Automation  - Lynkit",
    description: "LynkID offers asset tracking software with GPS, gate automation, and weighbridge automation to improve asset visibility, security, and operational efficiency.",
  },
  "/transport-management-system": {
    title: "AI-Powered Transport Management System Providers - India",
    description: "Lynkit is among the top AI-powered Transport Management System providers in India, offering Transportation Management Software for logistics and fleet operations.",
  },
  "/fleet-management-system": {
    title: "AI Based Fleet Management System & Vehicle Tracking - Lynkit",
    description: "Lynkit offers an AI-powered Fleet Management System with real-time fleet tracking and vehicle tracking, trusted by fleet management companies in India.",
  },
  "/products": {
    title: "Supply Chain Operation Products - Lynkit",
    description: "Explore Lynkit's full range of products, including TMS, WMS, and IoT-based tracking solutions for transport and warehouse management.",
  },
  "/videos": {
    title: "Videos - Lynkit",
    description: "Watch videos showcasing Lynkit's TMS, WMS, and logistics technology solutions in action.",
  },
  "/warehouse-management-system": {
    title: " AI Powered Warehouse Management System | Best WMS in India",
    description: " Lynkit's AI powered Warehouse Management System helps shippers and businesses streamline warehouse operations with smart storage, order fulfillment, & real-time visibility.",
  },
  "/xeneta": {
    title: "Ocean Freight Shipping & Freight Rate Management - Xeneta",
    description: "Monitor ocean freight shipping rates with a smart freight rate management platform. Track market trends using the container freight index and Xeneta Shipping Index.",
  },
  "/xeneta/roicalculator": {
    title: "Freight Rate ROI Calculator | Ocean Shipping - Xeneta",
    description: "Calculate your potential savings with Xeneta's Freight Rate ROI Calculator. Estimate cost benefits of smart ocean freight rate management for your business.",
  },
  "/xeneta/contact": {
    title: "Contact for Freight Shipping Rates - Xeneta",
    description: "Get in touch with Xeneta for queries on ocean freight shipping rates and freight rate management solutions. Request a demo today.",
  },
  "/xeneta/resources": {
    title: "Freight Rate Resources | Ocean Shipping - Xeneta",
    description: "Explore resources on ocean freight shipping rates, market trends, and freight rate management from Xeneta to make smarter shipping decisions.",
  },
  "/ai-layer": {
    title: "The AI-Powered Logistics Stack | Lynkit",
    description: "Explore Lynkit's end-to-end logistics technology stack spanning IoT, master data, AI, blockchain, smart contracts, and enterprise integrations.",
  },
};

const normalizePathname = (pathname) => {
  const normalizedPath = pathname.toLowerCase().replace(/\/+$/, "");
  return normalizedPath || "/";
};

function App() {
  const location = useLocation();
  const meta = pageMeta[normalizePathname(location.pathname)];

  // Disable browser's automatic scroll restoration — it fires too early
  // before lazy components load, causing wrong positions.
  // Instead, we save/restore scroll position manually via sessionStorage.
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    const saveScroll = () => {
      const scrollY = window.__lenis ? window.__lenis.scroll : window.scrollY;
      sessionStorage.setItem('scrollPos', scrollY);
    };

    window.addEventListener('beforeunload', saveScroll);
    return () => window.removeEventListener('beforeunload', saveScroll);
  }, []);

  let version=''
  let versionMismatch=false
  // const [version,setVersion]=useState('')  

  useEffect(() => {
    version=localStorage.getItem("version")
    setInterval(() => {
      versionCheck()
    }, 60000);  

    function versionCheck(){
      // console.log("Version Check",new Date());
      fetch("/assets/version.json?t="+new Date().getTime(),{
        method: "GET",
        headers:{
          "Content-Type": "application/json"
        }
      })
      .then((response) => response.json())
      .then((version1)=>{
        if(version1.hash && version1.hash!=version){
          // console.log("Will reload.....");
          if(!versionMismatch){
            versionMismatch=true
            setTimeout(() => {
              localStorage.setItem("version",version1.hash)
              window.location.reload(true)
            }, 2000);
          }
        }
      })
      .catch((err)=>{
        // console.log(err);
      })
    }
  }, [])


  return (
    <>
      <Navbar />
      <ScrollToTop />
      {/* <Helmet>
        <meta charSet="utf-8" />
        <title>Lynkit - Orchestrating Efficiency In Your Supply Chain </title>
        <meta name="description" content="Automate and digitally transform your supply chain with Lynkit's blockchain, telematics and IoT based logistics optimisation solutions." />
        <link rel="icon" type="image/png" href="lynkit.ico" sizes="32x32" />
      </Helmet> */}
      <React.Suspense fallback={<LoaderOverlay />}>
        <Switch>
          <Route exact path="/" component={Home} /> 
          <Route exact path="/:viewToScroll(products|enterprise)" component={Home} />
          <Route  path="About_us?key=2222218888" component={About_us} />
          {/* <Route exact path="/Company" component={Home} /> */}
          {/* <Route exact path="/Company" component={Home} /> */}

          {/* Redirect old /Home routes to new clean URLs */}
          <Redirect exact from="/Home/products" to="/products" />
          <Redirect exact from="/Home/enterprise" to="/enterprise" />
          <Redirect exact from="/Home" to="/" />     
          <Route exact path="/About_us" component={About_us} />
          <Route exact path="/About_us/:viewToScroll" component={About_us} />
          <Route exact path="/About_us/:viewToScroll" component={About_us} />
          <Route exact path='/usecases' component={UseCases}/>
          <Route exact path='/usecases/MPS_CaseStudy' component={CaseStudy1MPS}/>
          <Route exact path='/usecases/CMA_CGM_CaseStudy' component={CMA_CGM_CaseStudy}/>
          <Route exact path='/usecases/Haier_CaseStudy' component={Haier_CaseStudy}/>
          <Route exact path='/usecases/Flipkart_CaseStudy' component={Flipkart_CaseStudy}/>
          <Route exact path='/usecases/BlueDart_CaseStudy' component={BlueDart_CaseStudy}/>
          {/* <Route exact path='/usecases/DHL_CaseStudy' component={DHL_CaseStudy}/> */}
          <Route exact path='/usecases/ICD_CaseStudy' component={ICD_CaseStudy}/>
          <Route exact path="/Advisory_Board" component={Advisory_Board} />
          {/* <Route exact path="/Case_studies" component={Case_studies} /> */}
          <Route exact path="/knowledge-bank" component={KnowledgeBank} />
          <Route exact path='/e-book' component={Ebook}/>
          {/* <Route exact path='/videos' component={Videos}/> */}
          <Route exact path="/Api" component={Api} />
          <Route exact path="/knowledge-bank/posts" component={Posts} />
          <Route exact path="/Lynkhub" component={Lynkhub} />
          {/* <Route exact path="/blog" component={Blog} /> */}
          {/* <Route exact path="/blog/:id" component={BlogEntry} /> */}
          {/* <Route  path="/blog/:index" component={BlogEntry} />  */}
          {/* <Route exact path="/Case_study_1_GPS" component={Case_study_1_GPS} />
          <Route exact path="/Case_study_2" component={Case_study_2} />
          <Route exact path="/Case_study_3" component={Case_study_3} />
          <Route exact path="/Case_study_4" component={Case_study_4} />
          <Route exact path="/Case_study_5" component={Case_study_5} />
          <Route exact path="/Case_study_6" component={Case_study_6} /> */}
          <Route exact path="/ContactUs" component={ContactUs} />
          {/* <Route exact path="/Careers" component={Careers} /> */}
          <Route exact path="/fleet-management-system" component={LandingPage}/>
          <Route exact path="/transport-management-system" component={LynkitIOLandingPage}/> 
          <Route exact path='/warehouse-management-system' component={WMS}/>
          <Route exact path="/xeneta" component={Xeneta}/> 
          <Route exact path="/xeneta/resources" component={ResourcesXBL}/> 
          <Route exact path="/xeneta/contact" component={ContactUsXBL}/>
          <Route exact path="/xeneta/ROICalculator" component={ROICalculator}/>
          <Route exact path="/asset-tracking-system" component={LynkID}/> 
          {/* <Route exact path="/yard-management" component={YMS}/>  */}
          <Route exact path="/patent" component={Patent}/>
          <Route exact path="/privacy_policy" component={Privacy_policy}/>
          <Route exact path="/general_terms_of_use" component={General_terms_of_use}/>
          <Route exact path="/ai-layer" component={AiPage}/>

          <Route path="*" component={() => <Redirect to="/" />} /> 

        </Switch>
      </React.Suspense>
      {meta && (
        <Helmet>
          <title>{meta.title}</title>
          <meta name="description" content={meta.description} />
          <meta name="title" content={meta.title} />
        </Helmet>
      )}





    </>

  );  
};

export default App;
